import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  Course,
  Lesson,
  Module,
  CourseNavigation,
} from 'core/models/course-content.model';

@Injectable({
  providedIn: 'root',
})
export class CourseViewerService {
  // ==========================================================================
  // DADOS MOCKADOS (idênticos ao course-editor)
  // ==========================================================================

  private mockCourse: Course = {
    id: '1',
    title: 'Docker na Prática',
    description:
      'Curso completo sobre Docker com Thiago Veigah - Aprenda a criar e gerenciar containers Docker do zero',
    coverImage: undefined,
    totalProgress: 11,
    modules: [
      {
        id: 'module-1',
        name: 'Introdução ao Docker',
        description:
          'Conceitos fundamentais do Docker e sua importância no desenvolvimento moderno',
        contentType: 'lessons',
        order: 1,
        lessons: [
          {
            id: 'lesson-1-1',
            title: 'O que é o Docker e para que serve?',
            description:
              'Entenda os conceitos fundamentais do Docker, containers e como essa tecnologia revoluciona o desenvolvimento de software.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 15,
            completed: true,
            order: 1,
          },
          {
            id: 'lesson-1-2',
            title: 'Guia Completo: Conceitos de Containers',
            description:
              'Documentação detalhada sobre containers, imagens e a diferença entre Docker e virtualização tradicional.',
            type: 'pdf',
            pdfUrl: 'https://pdfobject.com/pdf/sample.pdf',
            duration: 20,
            completed: false,
            order: 2,
          },
          {
            id: 'lesson-1-3',
            title: 'História e Evolução do Docker',
            description:
              'Conheça a história do Docker, desde sua criação até os dias atuais, e entenda seu impacto na indústria.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 12,
            completed: false,
            order: 3,
          },
        ],
      },
      {
        id: 'module-2',
        name: 'Instalação e Configuração',
        description:
          'Aprenda a instalar e configurar o Docker em diferentes sistemas operacionais',
        contentType: 'lessons',
        order: 2,
        lessons: [
          {
            id: 'lesson-2-1',
            title: 'Como instalar o Docker no MacOS, Linux e Windows',
            description:
              'Passo a passo completo para instalar o Docker em diferentes plataformas e sistemas operacionais.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 18,
            completed: false,
            order: 1,
          },
          {
            id: 'lesson-2-2',
            title: 'Configuração Inicial e Primeiros Passos',
            description:
              'Aprenda a configurar o Docker após a instalação e execute seu primeiro container.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 14,
            completed: false,
            order: 2,
          },
          {
            id: 'lesson-2-3',
            title: 'Guia de Referência Rápida do Docker',
            description:
              'Documentação completa com comandos essenciais e boas práticas para uso do Docker.',
            type: 'pdf',
            pdfUrl: 'https://pdfobject.com/pdf/sample.pdf',
            duration: 25,
            completed: false,
            order: 3,
          },
          {
            id: 'lesson-2-4',
            title: 'Troubleshooting: Resolvendo Problemas Comuns',
            description:
              'Guia prático para resolver os problemas mais comuns durante a instalação e configuração do Docker.',
            type: 'pdf',
            pdfUrl: 'https://pdfobject.com/pdf/sample.pdf',
            duration: 12,
            completed: false,
            order: 4,
          },
        ],
      },
      {
        id: 'module-3',
        name: 'Containers e Imagens',
        description:
          'Domine a criação e gerenciamento de containers e imagens Docker',
        contentType: 'lessons',
        order: 3,
        lessons: [
          {
            id: 'lesson-3-1',
            title:
              'Criando uma imagem e um container Docker para uma aplicação',
            description:
              'Aprenda a criar sua primeira imagem Docker e executar containers para aplicações reais.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 22,
            completed: false,
            order: 1,
          },
          {
            id: 'lesson-3-2',
            title: 'Dockerfile: Guia Completo de Boas Práticas',
            description:
              'Documentação detalhada sobre como escrever Dockerfiles eficientes e seguir as melhores práticas da indústria.',
            type: 'pdf',
            pdfUrl: 'https://pdfobject.com/pdf/sample.pdf',
            duration: 30,
            completed: false,
            order: 2,
          },
          {
            id: 'lesson-3-3',
            title:
              'Como criar um Container de MongoDB e conectá-lo a uma aplicação',
            description:
              'Configure e gerencie containers de banco de dados MongoDB e conecte-os às suas aplicações.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 20,
            completed: false,
            order: 3,
          },
          {
            id: 'lesson-3-4',
            title: 'Como criar uma imagem Docker de uma SPA em React',
            description:
              'Containerize uma Single Page Application (SPA) React e prepare-a para produção.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 18,
            completed: false,
            order: 4,
          },
          {
            id: 'lesson-3-5',
            title: 'Gerenciamento de Imagens: Tags, Versões e Registries',
            description:
              'Aprenda a gerenciar versões de imagens, trabalhar com tags e usar registries públicos e privados.',
            type: 'pdf',
            pdfUrl: 'https://pdfobject.com/pdf/sample.pdf',
            duration: 16,
            completed: false,
            order: 5,
          },
        ],
      },
      {
        id: 'module-4',
        name: 'NGINX e Servindo Aplicações',
        description:
          'Aprenda a usar NGINX para servir aplicações em containers Docker',
        contentType: 'lessons',
        order: 4,
        lessons: [
          {
            id: 'lesson-4-1',
            title: 'O que é NGINX e para que serve?',
            description:
              'Conheça o NGINX, um servidor web de alto desempenho e como utilizá-lo em containers Docker.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 16,
            completed: false,
            order: 1,
          },
          {
            id: 'lesson-4-2',
            title: 'Configuração de NGINX: Guia de Referência',
            description:
              'Documentação completa sobre configuração de NGINX, incluindo exemplos práticos e casos de uso comuns.',
            type: 'pdf',
            pdfUrl: 'https://pdfobject.com/pdf/sample.pdf',
            duration: 22,
            completed: false,
            order: 2,
          },
          {
            id: 'lesson-4-3',
            title: 'Criando um container para o NGINX servir minha SPA',
            description:
              'Configure um container NGINX para servir sua Single Page Application de forma eficiente.',
            type: 'video',
            videoUrl: 'https://www.youtube.com/embed/4Z-raAFlHf4',
            duration: 17,
            completed: false,
            order: 3,
          },
        ],
      },
      {
        id: 'module-5',
        name: 'Avaliação Final',
        description:
          'Teste seus conhecimentos com diferentes tipos de questões sobre Docker',
        contentType: 'evaluations',
        order: 5,
        questions: [
          {
            id: 'q1',
            text: 'O que é um container Docker?',
            type: 'single-choice',
            points: 10,
            order: 0,
            correctAnswers: ['opt2'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Uma máquina virtual completa com sistema operacional próprio',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Um pacote isolado contendo uma aplicação e suas dependências',
              },
              {
                id: 'opt3',
                label: 'c',
                text: 'Um serviço de nuvem para hospedar aplicações',
              },
              {
                id: 'opt4',
                label: 'd',
                text: 'Uma linguagem de programação para desenvolvimento web',
              },
            ],
          },
          {
            id: 'q2',
            text: 'Qual comando Docker é usado para criar e iniciar um container a partir de uma imagem?',
            type: 'single-choice',
            points: 10,
            order: 1,
            correctAnswers: ['opt1'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'docker run',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'docker start',
              },
              {
                id: 'opt3',
                label: 'c',
                text: 'docker create',
              },
              {
                id: 'opt4',
                label: 'd',
                text: 'docker build',
              },
            ],
          },
          {
            id: 'q3',
            text: 'Quais são as principais vantagens do Docker?',
            type: 'multiple-choice',
            points: 15,
            order: 2,
            correctAnswers: ['opt1', 'opt2', 'opt4', 'opt5'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Isolamento de aplicações',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Portabilidade entre ambientes',
              },
              {
                id: 'opt3',
                label: 'c',
                text: 'Aumento do consumo de recursos',
              },
              {
                id: 'opt4',
                label: 'd',
                text: 'Facilidade de escalabilidade',
              },
              {
                id: 'opt5',
                label: 'e',
                text: 'Ambiente de desenvolvimento consistente',
              },
            ],
          },
          {
            id: 'q4',
            text: 'Quais comandos Docker são usados para gerenciar containers?',
            type: 'multiple-choice',
            points: 12,
            order: 3,
            correctAnswers: ['opt1', 'opt3', 'opt4'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'docker run',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'docker delete',
              },
              {
                id: 'opt3',
                label: 'c',
                text: 'docker ps',
              },
              {
                id: 'opt4',
                label: 'd',
                text: 'docker stop',
              },
              {
                id: 'opt5',
                label: 'e',
                text: 'docker remove',
              },
            ],
          },
          {
            id: 'q5',
            text: 'Docker é uma plataforma de virtualização de máquinas completas.',
            type: 'boolean',
            points: 5,
            order: 4,
            correctAnswers: ['opt2'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Verdadeiro',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Falso',
              },
            ],
          },
          {
            id: 'q6',
            text: 'Docker Compose permite orquestrar múltiplos containers através de um arquivo YAML.',
            type: 'boolean',
            points: 5,
            order: 5,
            correctAnswers: ['opt1'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Verdadeiro',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Falso',
              },
            ],
          },
          {
            id: 'q7',
            text: 'Uma imagem Docker é uma instância em execução de um container.',
            type: 'boolean',
            points: 5,
            order: 6,
            correctAnswers: ['opt2'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Verdadeiro',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Falso',
              },
            ],
          },
          {
            id: 'q8',
            text: 'O Dockerfile é usado para definir como construir uma imagem Docker.',
            type: 'boolean',
            points: 5,
            order: 7,
            correctAnswers: ['opt1'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Verdadeiro',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Falso',
              },
            ],
          },
          {
            id: 'q9',
            text: 'Qual é a diferença entre uma imagem e um container Docker?',
            type: 'single-choice',
            points: 10,
            order: 8,
            correctAnswers: ['opt3'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Não há diferença, são a mesma coisa',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Imagem é o código-fonte e container é o executável',
              },
              {
                id: 'opt3',
                label: 'c',
                text: 'Imagem é um template e container é uma instância em execução da imagem',
              },
              {
                id: 'opt4',
                label: 'd',
                text: 'Imagem é para desenvolvimento e container é para produção',
              },
            ],
          },
          {
            id: 'q10',
            text: 'Quais recursos do Docker ajudam na portabilidade de aplicações?',
            type: 'multiple-choice',
            points: 12,
            order: 9,
            correctAnswers: ['opt1', 'opt2', 'opt3'],
            options: [
              {
                id: 'opt1',
                label: 'a',
                text: 'Isolamento de dependências',
              },
              {
                id: 'opt2',
                label: 'b',
                text: 'Ambiente consistente entre desenvolvimento e produção',
              },
              {
                id: 'opt3',
                label: 'c',
                text: 'Compatibilidade multiplataforma',
              },
              {
                id: 'opt4',
                label: 'd',
                text: 'Requer configuração manual em cada ambiente',
              },
            ],
          },
        ],
      },
    ],
  };

  private currentLessonId = 'lesson-1-1'; // Lição atual mockada

  // ==========================================================================
  // OBSERVABLES PÚBLICOS
  // ==========================================================================

  private lessonChangeSubject = new BehaviorSubject<string>(
    this.currentLessonId,
  );
  public lessonChange$: Observable<string> =
    this.lessonChangeSubject.asObservable();

  // ==========================================================================
  // MÉTODOS PÚBLICOS
  // ==========================================================================

  /**
   * Obtém o curso completo
   */
  public getCourse(): Course {
    return this.mockCourse;
  }

  /**
   * Obtém o curso com módulos de avaliações convertidos em lessons para exibição no sidebar
   */
  public getCourseForSidebar(): Course {
    const courseWithConvertedModules: Course = {
      ...this.mockCourse,
      modules: this.mockCourse.modules.map((module) => {
        if (module.contentType === 'evaluations' && module.questions) {
          const lessons = this.convertQuestionsToLessons(module);
          return {
            ...module,
            contentType: 'lessons' as const,
            lessons: lessons,
          };
        }
        return module;
      }),
    };
    return courseWithConvertedModules;
  }

  /**
   * Converte questões de um módulo de avaliações em lições dinamicamente
   * Cria uma lição individual para cada questão (igual ao editor)
   */
  public convertQuestionsToLessons(module: Module): Lesson[] {
    if (module.contentType !== 'evaluations' || !module.questions) {
      return [];
    }

    const lessons: Lesson[] = [];
    const questions = module.questions; // Variável local para garantir que não é undefined

    // Ordenar questões pelo order
    const sortedQuestions = [...questions].sort((a, b) => a.order - b.order);

    // Criar uma lição individual para cada questão (igual ao editor)
    sortedQuestions.forEach((question) => {
      // Usar apenas o texto da questão como título (sem número, pois o sidebar já adiciona)
      // O número vem do order da questão (order + 1 para exibição, já que order começa em 0)
      const title =
        question.text.length > 50
          ? question.text.substring(0, 50) + '...'
          : question.text;

      lessons.push({
        id: `lesson-${module.id}-${question.id}`,
        title: title,
        description: question.text,
        type: 'evaluation',
        duration: 5,
        completed: false,
        order: question.order + 1, // Usar order da questão + 1 (order começa em 0)
        evaluationData: {
          title: 'Avaliação Final',
          subtitle: 'Responda a questão abaixo.',
          totalPoints: question.points,
          questions: [question],
        },
      });
    });

    // Adicionar lição de resultados no final
    lessons.push({
      id: `lesson-${module.id}-results`,
      title: 'Resultados da Avaliação',
      description:
        'Confira seu desempenho e feedback detalhado de todas as questões.',
      type: 'evaluation-results',
      duration: 5,
      completed: false,
      order: lessons.length + 1,
    });

    return lessons;
  }

  /**
   * Obtém a lição atual (incluindo lições convertidas de questões)
   */
  public getCurrentLesson(): Lesson | null {
    for (const module of this.mockCourse.modules) {
      if (module.contentType === 'lessons' && module.lessons) {
        const lesson = module.lessons.find(
          (l) => l.id === this.currentLessonId,
        );
        if (lesson) {
          return lesson;
        }
      } else if (module.contentType === 'evaluations' && module.questions) {
        const lessons = this.convertQuestionsToLessons(module);
        const lesson = lessons.find((l) => l.id === this.currentLessonId);
        if (lesson) {
          return lesson;
        }
      }
    }
    return null;
  }

  /**
   * Obtém o módulo atual baseado na lição atual (com lessons[] convertidas se necessário)
   */
  public getCurrentModule(): Module | null {
    for (const module of this.mockCourse.modules) {
      if (module.contentType === 'lessons' && module.lessons) {
        const lesson = module.lessons.find(
          (l) => l.id === this.currentLessonId,
        );
        if (lesson) {
          return module;
        }
      } else if (module.contentType === 'evaluations' && module.questions) {
        const lessons = this.convertQuestionsToLessons(module);
        const lesson = lessons.find((l) => l.id === this.currentLessonId);
        if (lesson) {
          // Retornar módulo com lessons[] convertidas para compatibilidade
          return {
            ...module,
            contentType: 'lessons' as const,
            lessons: lessons,
          };
        }
      }
    }
    return null;
  }

  /**
   * Obtém informações de navegação
   */
  public getNavigation(): CourseNavigation {
    const currentLesson = this.getCurrentLesson();
    const currentModule = this.getCurrentModule();

    if (!currentLesson || !currentModule) {
      return {
        currentModule: null,
        currentLesson: null,
        currentModuleIndex: -1,
        currentLessonIndex: -1,
        canGoPrevious: false,
        canGoNext: false,
      };
    }

    const moduleIndex = this.mockCourse.modules.findIndex(
      (m) => m.id === currentModule.id,
    );
    const lessonIndex = currentModule.lessons
      ? currentModule.lessons.findIndex((l) => l.id === currentLesson.id)
      : -1;

    // Verificar se pode ir para anterior
    const canGoPrevious = moduleIndex > 0 || lessonIndex > 0;

    // Verificar se pode ir para próximo
    const canGoNext: boolean =
      moduleIndex < this.mockCourse.modules.length - 1 ||
      !!(
        currentModule.contentType === 'lessons' &&
        currentModule.lessons &&
        lessonIndex < currentModule.lessons.length - 1
      );

    return {
      currentModule,
      currentLesson,
      currentModuleIndex: moduleIndex,
      currentLessonIndex: lessonIndex,
      canGoPrevious,
      canGoNext,
    };
  }

  /**
   * Navega para a lição anterior
   */
  public goToPreviousLesson(): boolean {
    const navigation = this.getNavigation();

    if (
      !navigation.canGoPrevious ||
      !navigation.currentModule ||
      !navigation.currentLesson
    ) {
      return false;
    }

    const { currentModuleIndex, currentLessonIndex } = navigation;

    // Se não é a primeira lição do módulo, vai para a anterior
    if (currentLessonIndex > 0 && navigation.currentModule.lessons) {
      const previousLesson =
        navigation.currentModule.lessons[currentLessonIndex - 1];
      this.currentLessonId = previousLesson.id;
      this.lessonChangeSubject.next(this.currentLessonId);
      return true;
    }

    // Se é a primeira lição, vai para a última lição do módulo anterior
    if (currentModuleIndex > 0) {
      const previousModule = this.mockCourse.modules[currentModuleIndex - 1];
      if (
        previousModule.contentType === 'lessons' &&
        previousModule.lessons &&
        previousModule.lessons.length > 0
      ) {
        const lastLesson =
          previousModule.lessons[previousModule.lessons.length - 1];
        this.currentLessonId = lastLesson.id;
        this.lessonChangeSubject.next(this.currentLessonId);
        return true;
      } else if (
        previousModule.contentType === 'evaluations' &&
        previousModule.questions
      ) {
        const lessons = this.convertQuestionsToLessons(previousModule);
        if (lessons.length > 0) {
          const lastLesson = lessons[lessons.length - 1];
          this.currentLessonId = lastLesson.id;
          this.lessonChangeSubject.next(this.currentLessonId);
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Navega para a próxima lição
   */
  public goToNextLesson(): boolean {
    const navigation = this.getNavigation();

    if (
      !navigation.canGoNext ||
      !navigation.currentModule ||
      !navigation.currentLesson
    ) {
      return false;
    }

    const { currentModuleIndex, currentLessonIndex, currentModule } =
      navigation;

    // Se não é a última lição do módulo, vai para a próxima
    if (
      currentModule.lessons &&
      currentLessonIndex < currentModule.lessons.length - 1
    ) {
      const nextLesson = currentModule.lessons[currentLessonIndex + 1];
      this.currentLessonId = nextLesson.id;
      this.lessonChangeSubject.next(this.currentLessonId);
      return true;
    }

    // Se é a última lição, vai para a primeira lição do próximo módulo
    if (currentModuleIndex < this.mockCourse.modules.length - 1) {
      const nextModule = this.mockCourse.modules[currentModuleIndex + 1];
      if (
        nextModule.contentType === 'lessons' &&
        nextModule.lessons &&
        nextModule.lessons.length > 0
      ) {
        const firstLesson = nextModule.lessons[0];
        this.currentLessonId = firstLesson.id;
        this.lessonChangeSubject.next(this.currentLessonId);
        return true;
      } else if (
        nextModule.contentType === 'evaluations' &&
        nextModule.questions
      ) {
        const lessons = this.convertQuestionsToLessons(nextModule);
        if (lessons.length > 0) {
          const firstLesson = lessons[0];
          this.currentLessonId = firstLesson.id;
          this.lessonChangeSubject.next(this.currentLessonId);
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Navega para uma lição específica
   */
  public goToLesson(lessonId: string): void {
    this.currentLessonId = lessonId;
    this.lessonChangeSubject.next(this.currentLessonId);
  }

  /**
   * Calcula o progresso total do curso
   */
  public calculateTotalProgress(): number {
    let totalLessons = 0;
    let completedLessons = 0;

    this.mockCourse.modules.forEach((module) => {
      if (module.contentType === 'lessons' && module.lessons) {
        totalLessons += module.lessons.length;
        completedLessons += module.lessons.filter((l) => l.completed).length;
      }
    });

    return totalLessons > 0
      ? Math.round((completedLessons / totalLessons) * 100)
      : 0;
  }

  /**
   * Calcula o tempo restante estimado
   */
  public calculateRemainingTime(): string {
    let remainingMinutes = 0;

    const navigation = this.getNavigation();
    if (!navigation.currentModule) {
      return '~0 min';
    }

    // Tempo da lição atual
    if (navigation.currentLesson) {
      remainingMinutes += navigation.currentLesson.duration;
    }

    // Tempo das lições restantes no módulo atual
    if (
      navigation.currentLessonIndex !== undefined &&
      navigation.currentModule &&
      navigation.currentModule.lessons
    ) {
      const remainingLessonsInModule = navigation.currentModule.lessons.slice(
        navigation.currentLessonIndex + 1,
      );
      remainingLessonsInModule.forEach((lesson) => {
        remainingMinutes += lesson.duration;
      });
    }

    // Tempo dos módulos restantes
    if (navigation.currentModuleIndex !== undefined) {
      const remainingModules = this.mockCourse.modules.slice(
        navigation.currentModuleIndex + 1,
      );
      remainingModules.forEach((module) => {
        if (module.contentType === 'lessons' && module.lessons) {
          module.lessons.forEach((lesson) => {
            remainingMinutes += lesson.duration;
          });
        }
      });
    }

    if (remainingMinutes < 60) {
      return `~${remainingMinutes} min`;
    }

    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;
    return minutes > 0 ? `~${hours}h ${minutes}min` : `~${hours}h`;
  }

  /**
   * Calcula o progresso da lição atual (mockado)
   */
  public getCurrentLessonProgress(): number {
    return 60; // Mockado em 60%
  }
}
